'use client'

import { useMemo } from 'react'
import { IconArrowLeft } from '@tabler/icons-react'
import clsx from 'clsx'
import Image from 'next/image'
import Link from 'next/link'
import { usePathname, useRouter } from 'next/navigation'

import Button from 'shared/ui/Button'
import {
  getDestinationFromPathname,
  getPathFromDestination,
  PATHS
} from 'shared/utils/paths'
import { addTestId } from 'shared/utils/tests'

import styles from './AuthNavigation.module.scss'

const AuthNavigationWeb = ({ className }: { className?: string }) => {
  const router = useRouter()
  const pathname = usePathname()

  const destination = useMemo(
    () => getDestinationFromPathname(pathname || ''),
    [pathname]
  )

  return (
    <div className={clsx(styles.wrapper, className)}>
      <div className={styles.content}>
        <Link
          className={styles.logoLink}
          href={PATHS.home}
          {...addTestId('navigation-logo')}
        >
          <Image
            src='/static/lokalny-rolnik.svg'
            alt='Logo Lokalny Rolnik'
            width={139}
            height={43}
          />
        </Link>
        <div className={styles.actions}>
          <div className={styles.navLinks}>
            <div className={styles.webContent}>
              <Button
                id='authentication_return_to_homepage_button'
                onClick={() => router.push(PATHS.home)}
                variant='neutralOutline'
                startIcon={<IconArrowLeft />}
              >
                Powrót do strony głównej
              </Button>
            </div>

            <div className={styles.tabletContent}>
              <Button
                id='authentication_return_button'
                onClick={() =>
                  router.push(
                    destination
                      ? getPathFromDestination(destination)
                      : PATHS.home
                  )
                }
                variant='neutralOutline'
                startIcon={<IconArrowLeft />}
              >
                Powrót
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AuthNavigationWeb
